import {
    Button,
    Card,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    TextField,
    Box,
    CardMedia,
    Stack,
    Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import moment from "moment";
import React, {
    useEffect,
    useState
} from "react";
import { connect } from "react-redux";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";
import { styled } from '@mui/material/styles';
import { useDropzone } from 'react-dropzone';
import { appVersionCreate, appVersionCreateErrorClear } from "store/app/app-management/app-version/actions";
import UploadCover from 'assets/images/upload/upload.svg';
import SubCard from "ui-component/cards/SubCard";

const DropzoneWrapper = styled('div')(({ theme }) => ({
    outline: 'none',
    overflow: 'hidden',
    position: 'relative',
    padding: theme.spacing(2, 2),
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('padding'),
    backgroundColor: theme.palette.background.paper,
    border: `1px dashed ${theme.palette.primary.main}`,
    '&:hover': { opacity: 0.72, cursor: 'pointer' }
}));

const AddAppVersion = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending } = props;

    const [appVersionData, setAppVersionData] = useState();
    const [file, setFile] = useState();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        props.appVersionCreateErrorClear();
        setAppVersionData({ ReleasedDate: moment().format("YYYY-MM-DD") });
        setErrors({});
        setFile();
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e && e.target;
        setAppVersionData({
            ...appVersionData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const validateOnDate = (name, date) => {
        const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;
        setAppVersionData({
            ...appVersionData,
            [name]: formattedDate
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleChangePassword = (e) => {
        e.preventDefault();

        const { VersionNo, ReleasedDate } = appVersionData || {};
        const currentErrors = {};

        if (!VersionNo && !VersionNo?.trim()) {
            currentErrors.VersionNo = 'Version no is required';
        }
        if (!ReleasedDate && !ReleasedDate?.trim()) {
            currentErrors.ReleasedDate = 'Released date is required';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.appVersionCreate({ ...appVersionData, AppAPK: file }, filter, paginationData);
        }
    }

    //----------------UPLOAD APK---------------------------------------------------
    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
        accept: {
            '.apk,application/vnd.android.package-archive': []
        },
        multiple: false,
        onDrop: (acceptedFiles) => {
            setFile(
                //   'files',
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    })
                )
            );
        }
    });

    const thumbs =
        file &&
        file.map((item, index) => (
            <Box
                key={index}
                sx={{ bgcolor: 'background.paper', top: 8, left: 0, borderRadius: 2, position: 'absolute', width: 1, height: 1 }}
            >
                <img
                    alt={item.name}
                    src={item.preview}
                    style={{ width: 'calc(100% - 16px)', height: 'calc(100% - 16px' }}
                    onLoad={() => {
                        URL.revokeObjectURL(item.preview);
                    }}
                />
            </Box>
        ));

    const onRemove = () => {
        setFile(null);
    };

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Add App Version
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    autoFocus
                                                    label={<div >Version No<Required /></div>}
                                                    fullWidth
                                                    size="small"
                                                    name='VersionNo'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    error={errors?.VersionNo}
                                                    helperText={errors?.VersionNo}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label={<div >Released Date<Required /></div>}
                                                        onChange={(date) => validateOnDate("ReleasedDate", date)}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={moment.utc(appVersionData?.ReleasedDate, "YYYY-MM-DD")}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                                error: errors?.ReleasedDate,
                                                                helperText: errors?.ReleasedDate
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label={<>Notes </>}
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    size="small"
                                                    name='Notes'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                />
                                            </Grid>
                                            <SubCard title="Select APK File" sx={{ whiteSpace: "wrap" }}>
                                                <Grid item sx={{ padding: "20px" }}>
                                                    <DropzoneWrapper
                                                        {...getRootProps()}
                                                        sx={{
                                                            ...(isDragActive && { opacity: 0.72 }),
                                                            ...((isDragReject || errorMessage) && { color: 'error.main', borderColor: 'error.light', bgcolor: 'error.lighter' }),
                                                            ...(file && { padding: '12% 0' })
                                                        }}
                                                    >
                                                        <input {...getInputProps()} />
                                                        <Stack
                                                            spacing={1}
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            direction={{ xs: 'column', md: 'row' }}
                                                            sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
                                                        >
                                                            <CardMedia component="img" image={UploadCover} sx={{ width: 100 }} />
                                                            <Stack sx={{ p: 0 }} spacing={1}>
                                                                <Typography variant="h5">Drag & Drop or Select APK</Typography>
                                                                <Typography color="secondary.main">
                                                                    Drop APK files here or click&nbsp;
                                                                    <Typography component="span" color="primary" sx={{ textDecoration: 'underline' }}>
                                                                        browse
                                                                    </Typography>
                                                                    &nbsp;through your machine
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                        {thumbs}
                                                    </DropzoneWrapper>
                                                    {file && file.length > 0 && (
                                                        <Grid container direction="row" justifyContent="flex-end" sx={{ mt: 1.5 }}>
                                                            <Button variant="contained" color="error" onClick={onRemove}>
                                                                Remove
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </SubCard>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleChangePassword}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.appVersions.isAppVersionCreatePending,
    errorMessage: state.appVersions.appVersionCreateErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    appVersionCreate: (formData, filter, paginationData) => dispatch(appVersionCreate(formData, filter, paginationData)),
    appVersionCreateErrorClear: () => dispatch(appVersionCreateErrorClear()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddAppVersion);